export enum MessageContextActionType {
  SET_JOB_ID = 'message/setJobId',
  CLEAR_JOB_ID = 'message/clearJobId',
}

export type MessageContextAction =
  | {
      type: MessageContextActionType.SET_JOB_ID;
      jobId: string;
    }
  | {
      type: MessageContextActionType.CLEAR_JOB_ID;
    };

export type MessageContextState = {
  jobId: string;
};

export type MessageContextDispatch = (action: MessageContextAction) => void;

export type MessageContextType = {
  state: MessageContextState;
  dispatch: MessageContextDispatch;
};
